import { QuestionsSort } from './QuestionsSort';
export default QuestionsSort;
